import { KeyboardEventDefinition } from '@plugins/shared/utils/checkKeyboardEvent';

export const SUBMIT_RESPONSE_SHORTCUT: KeyboardEventDefinition = {
  key: 'Enter',
  shiftKey: true,
};

export const PRIMENG_BLUE_CONTROL = '#007bff';
